module.exports = __webpack_public_path__ + "static/media/tudublin.1ccc8acd.jpg";